import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepThreeExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepThreeExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.climbStepThreeExtraLevels.data.climbStepThreeExtraLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
